import {versoMebelSellerRequisites} from "../data/ContactsVersoMebel";
import {isKuhniVersoMebelDomain} from "./isKuhniVersoMebelDomain";

const formatFieldValue = (value) => (value == null || value === "" ? "" : String(value));

/** Same contact values as on `/contacts` (Contacts.jsx). */
export const getContactsPageFieldGroups = () => {
    if (isKuhniVersoMebelDomain()) {
        return {
            left: [
                {key: "name", label: "Наименование", value: formatFieldValue(versoMebelSellerRequisites.name)},
                {key: "address", label: "Адрес", value: formatFieldValue(versoMebelSellerRequisites.address)},
                {key: "unp", label: "УНП", value: formatFieldValue(versoMebelSellerRequisites.unp)},
            ],
            right: [
                {
                    key: "account",
                    label: "Расчетный счет",
                    value: formatFieldValue(versoMebelSellerRequisites.account),
                },
                {key: "bank", label: "Отделение банка", value: formatFieldValue(versoMebelSellerRequisites.bank)},
                {
                    key: "phone",
                    label: "Тел. (факс)",
                    value: formatFieldValue(versoMebelSellerRequisites.phone),
                },
            ],
        };
    }

    return {
        left: [
            {key: "email", label: "Email", value: "info@upme.by"},
            {key: "phone", label: "Телефон", value: "+375 44 73 24 144"},
        ],
        right: [
            {
                key: "legal",
                label: "Организация",
                value: "ООО «АЙТИ ДЖУС» УНП: 591397311",
            },
        ],
    };
};
